import { IAppliedCouponCodeDetails } from "repoV2/features/Common/modules/FormData/interfaces/IAppliedCouponCodeDetails";

export const coupon_code_input_field_name = "coupon_code";

/**
 * coupon code input field helper text types
 */
export const helper_text_types = {
    success: "success",
    error: "error",
    empty: "empty",
} as const;

export const loyalty_error_strings = {
    required: "Required",
    invalid_email: "Invalid Email",
    email_already_exists: "User with this email already exists",
};

export const loyalty_email = "loyalty_email";
export const default_applied_coupon_code_details: IAppliedCouponCodeDetails = {
    applied: false,
};

// This is used to differentiate between Loyalty and Promotional Coupon types
// We need to differentiate in them as loyalty coupons are only for some specific loyal
// customers s
export const COUPON_TYPES = {
    LOYALTY_COUPON: 1,
    PROMOTIONAL_COUPON: 2,
};

// These are the values that the backend will accept in apply coupon api
export const DISCOUNT_CODE_TYPES = {
    NORMAL: "normal",
    LOYALTY: "loyalty", // when a previous customer comes for booking again
};

// react-hook-form key for the applied coupon
export const applied_coupon_form_key = "applied_coupon_code_details";
